import _ from 'lodash';
import { mapGetters } from 'vuex';
import { BILLING_CYCLE, planTypes } from '@/common/constants';
import { pageConfig } from '@/common/service/page-config';
import { isFromPartnerCampaign } from '@/views/config/partner-refer/helper/utils';
import { isFromCampaignLink } from '@/views/config/coupon/helper/utils';
import { plansof } from '@/utils/chain';

const EDIT_INELIGIBLE_CASE_MAP = {
  m2a: 0,
  a2a: 1,
  m2m: 2
}

export default {
  computed: {
    ...mapGetters(['partnerRefer', 'currentEditPlan', 'planMapFlat', 'getBoughtBasePlanInfo', 'getSelectedBasePlanInfo', 'getSelectedPlans', 'boughtPlans']),
    eligibleInfoForPromoCase() {
      if (this.$context.is.edit && (isFromPartnerCampaign() || isFromCampaignLink())) {
        const planType = this.currentEditPlan?.type;
        const billingCycle = this.currentEditPlan?.billing_cycle;
        const category = this.currentEditPlan?.category;

        // m2a case
        if (billingCycle === BILLING_CYCLE.MONTHLY) {
          const currentAnnualPlanCodes4Edit = this.getAnnualPlanByMonthlyCurrentEditPlan({ planType, category });
          const preloadPlanCodeList = this.getTargetPlanCodeList();
          const m2aCase = _.some(preloadPlanCodeList, (planCode) => {
            return _.includes(currentAnnualPlanCodes4Edit, planCode);
          });

          if (m2aCase) {
            return {
              min: true,
              reason: EDIT_INELIGIBLE_CASE_MAP.m2a,
            };
          }
        }

        // current edit plan billing cycle is annual plan
        if (billingCycle === BILLING_CYCLE.ANNUAL) {
          // current edit base plan have been cancelled
          if (this.currentBasePlanHaveBeenCancelled) {
            // a2a case, not allow customer to switch billing cycle to monthly
            const currentTargetPlanCodes4Edit = this.getTargetPlanCodeListByCurrentEditPlan({ planType, category, billingCycle });
            const preloadPlanCodeList = this.getTargetPlanCodeList();
            const a2aCase = _.some(preloadPlanCodeList, (planCode) =>  _.includes(currentTargetPlanCodes4Edit, planCode));

            if (a2aCase) {
              return {
                min: false,
                reason: '',
                key: BILLING_CYCLE.MONTHLY,
              };
            }
          }
        }
      }

      // meeting pro upgrade to biz+ or meeting biz upgrade to biz+
      if ((this.$context.is.pro2bundle || this.$context.is.biz2bundle) && isFromCampaignLink()) {
        const meetingPlanHaveBeenCancelled = plansof(this.boughtPlans).type(planTypes.ZOOM_MEETING).get(0)?.cancelled === 1;

        if (meetingPlanHaveBeenCancelled) {
          const preloadPlanCodeList = this.getTargetPlanCodeList();
          const callingPlan = plansof(this.planMapFlat)
            .type(planTypes.ZOOM_ONE_BUNDLE)
            .filter((p) => _.includes(preloadPlanCodeList, p?.plan_code))
            .get(0);

          return {
            reason: '',
            targetPromoPlan: callingPlan,
            disabledBillingCycleList: callingPlan ? _.values(BILLING_CYCLE).filter((b) => b !== callingPlan.billing_cycle) : [],
          };
        }
      }

      return {
        min: false,
        reason: '',
      };
    },
    currentBasePlanHaveBeenCancelled() {
      return this.currentEditPlan?.cancelled === 1;
    },
  },
  methods: {
    getTargetPlanCodeListByCurrentEditPlan({ planType, category, billingCycle }) {
      return _.chain(this.getSelectedPlans)
        .filter((p) =>
          p.type === planType
          && p?.category === category
          && p.billing_cycle === billingCycle,
        )
        .map((p) => p.plan_code)
        .value();
    },
    getAnnualPlanByMonthlyCurrentEditPlan({ planType, category }) {
      return this.getTargetPlanCodeListByCurrentEditPlan({ planType, category, billingCycle: BILLING_CYCLE.ANNUAL });
    },
    getTargetPlanCodeList() {
      if (isFromPartnerCampaign()) {
        const partnerCoupon = this.partnerRefer?.coupon || {};
        return this.partnerRefer?.preloadPlan || _.keys({
          ...partnerCoupon?.discountInfo,
          ...partnerCoupon?.discountInfoExtension,
        });
      } else if (isFromCampaignLink()) {
        const marketingCoupon = pageConfig?.marketingCoupon || {};
        return _.keys({
          ...marketingCoupon?.discountInfo,
          ...marketingCoupon?.discountInfoExtension,
        });
      }
    },
    getDownsellDisabledReasonForPromotion({reason, boughtLicense}) {
      if (reason === EDIT_INELIGIBLE_CASE_MAP.m2a) {
        return this.$t('billing.coupon.downsell_edit_reason', [boughtLicense])
      }

      return '';
    }
  },
};
